<template>
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_3325_48134)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.44682 1.5672C8.53256 1.17749 8.87785 0.899902 9.27688 0.899902H9.32835C10.8956 0.899902 12.0711 2.33374 11.7637 3.87058L11.2329 6.5249H14.8216C16.4333 6.5249 17.5869 8.08185 17.1177 9.62369L15.5883 14.6487C15.2807 15.6593 14.3486 16.3499 13.2923 16.3499H5.02539L5.02539 7.4999C5.02539 7.38731 4.98995 7.283 4.92962 7.19752L5.05669 7.09332C6.77518 5.6842 7.96934 3.73765 8.44682 1.5672ZM3.97539 7.8749H1.87598C1.46176 7.8749 1.12598 8.21069 1.12598 8.6249V15.3749C1.12598 15.7891 1.46176 16.1249 1.87598 16.1249H3.97539L3.97539 7.8749Z"
        fill="#DB382C"
      />
    </g>
    <defs>
      <clipPath id="clip0_3325_48134">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script lang="ts">
export default {
  data() {
    return {};
  },
};
</script>
